// 内置图标清单与解析。
// 资源位于 src/assets/icon/*.svg（与 IAM 侧同一套 SVG）。
// 使用 webpack require.context 动态收集，免去手写清单 / 生成脚本。
const iconCtx = require.context('./', false, /\.svg$/)

/** 内置图标文件名数组，形如 ['icon (1).svg', 'icon (2).svg', ...] */
export const ICON_LIST = iconCtx.keys().map((key) => key.replace('./', ''))

/**
 * 解析图标值 -> 可直接用于 <img :src> 的地址
 * - 空               -> ''
 * - http(s) / 协议相对 -> 原样返回（上传得到的图片 URL）
 * - 内置文件名        -> 本地打包后的资源地址
 * @param {String} value 内置图标文件名 或 图片完整 URL
 * @returns {String}
 */
export function resolveIcon(value) {
  if (!value) return ''
  if (/^(https?:)?\/\//.test(value)) return value
  try {
    return iconCtx('./' + value)
  } catch (e) {
    return ''
  }
}
